import { render } from "./ChevronLeftIcon.vue?vue&type=template&id=63ff1a4a"
import script from "./ChevronLeftIcon.vue?vue&type=script&lang=js"
export * from "./ChevronLeftIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__